import React from "react";
import "./ActionPanel.scss";

const ActionPanel = (props) => {
  const { actions, selectedRows } = props;

  if (actions.length === 0) {
    return null;
  }
  return (
    <div className="ActionPanel" data-testid="ActionPanel">
      <div className="action-panel-inner">
        <ul>
          {actions.map((action) => {
            return (
              <li key={action.label}>
                {action.link ? 
                ( <a href={action.link}
                    target="_self"
                  >
                    <span className={"text"}>
                      {action.label.replace("#N#", selectedRows.length)}
                    </span>
                    {action.icon && <span className="icon">{action.icon}</span>}
                  </a>) : 
                  (<button
                    type="button"
                    onClick={action.onCLick ? action.onCLick : props.onClick}
                  >
                    <span className={"text"}>
                      {action.label.replace("#N#", selectedRows.length)}
                    </span>
                    {action.icon && <span className="icon">{action.icon}</span>}
                  </button>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default ActionPanel;
